import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import fuse from '../../../_libs/redux-fusion';
import {getUserId} from '../../../auth/reducers';
import {UserViewActivityView} from './UserViewActivityView';


const StreamedComponent = (state$, dispatch) => (props$) => {
  const userId$ = state$
    .map(getUserId)
    .distinctUntilChanged()
    .takeUntil(props$.last())
    .filter(userId => !!userId);

  return props$
    .combineLatest(
      userId$,
      (props, userId) => ({
        ...props,
        feedId: userId,
        isOwnFeed: false,
      }));
};

export const UserViewActivityContainer = fuse(StreamedComponent)(UserViewActivityView);



// WEBPACK FOOTER //
// ./src/js/user/components/UserViewActivity/UserViewActivityContainer.js